import {
    REQUEST_NOTIFICATIONS,
    RECEIVE_NOTIFICATIONS,
    UPDATE_NOTIFICATIONS,
    ERROR_NOTIFICATIONS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import _cloneDeep from "lodash/cloneDeep"
import _get from "lodash/get"
import {loadDataRefresh} from "../../constants/constants"

const s = {last: {}, all: {}}

export default (state = s, action = {}) => {
    const newState = _cloneDeep(state)
    const subtype = action.subtype

    switch(action.type) {
        case REQUEST_NOTIFICATIONS:
            if(action.item){
                newState[subtype].isFetching = true
            }else{
                newState[subtype] = {
                    ...initialFetchState,
                    data: newState[subtype].data,
                    isFetching: true,
                    message: '',
                    errors: {}
                }
            }
            return newState
        case RECEIVE_NOTIFICATIONS:
            newState[subtype] = {
                ...newState[subtype],
                isFetching: false,
                validUntil: loadDataRefresh.none + Date.now(),
                message: '',
                errors: {}
            }
            if(action.payload){
                if(subtype == "last"){
                    const res = _get(action.payload, "results", []).concat(_get(newState[subtype], "data.results", []))
                    newState[subtype].data = action.payload
                    newState[subtype].data.results = res
                }else{
                    newState[subtype].data = action.payload
                }
            }

            return newState
        case UPDATE_NOTIFICATIONS:
            const data = newState[subtype].data
            if(data.results){
                data.results.map(r => {
                    if(action.id.includes(r.id)){
                        r.has_read = true
                        const d = new Date()
                        r.read_timestamp = d.toISOString()
                    }
                })
            }
            newState[subtype] = {
                ...newState[subtype],
                isFetching: false,
                data: data,
                message: '',
                errors: action.errors
            }
            return newState
        case ERROR_NOTIFICATIONS:
            newState[subtype] = {
                ...newState[subtype],
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
            return newState
        default:
            return state
    }
}